import { Reaction } from '@moleculeone/types';

export type ReversedProductMap = {
  [atomIdx: string]: number;
};

export type ReversedSubstratesMap = {
  [atomIdx: string]: number[];
};

type ReversedMapping = {
  mapToProduct: ReversedProductMap;
  mapToSubstrates: ReversedSubstratesMap;
};

export function reverseMapping(
  productMap: Reaction['productMap'],
  substratesMap: Reaction['substratesMap']
): ReversedMapping {
  if (!productMap || !substratesMap) {
    return {
      mapToProduct: {},
      mapToSubstrates: {},
    };
  }

  const mapToSubstrates = substratesMap.reduce<ReversedSubstratesMap>((acc, substrateMap, subId) => {
    substrateMap.forEach((atom, atomId) => {
      acc[atom] = [subId, atomId];
    });
    return acc;
  }, {});

  const mapToProduct = productMap.reduce<ReversedProductMap>((acc, atom, atomId) => {
    acc[atom] = atomId;
    return acc;
  }, {});

  return {
    mapToProduct,
    mapToSubstrates,
  };
}
